import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import axios from 'axios';

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

axios.defaults.paramsSerializer = function (paramObj) {
    const params = new URLSearchParams()
    for (const key in paramObj) {
        params.append(key, paramObj[key])
    }

    return params.toString()
}

axios.defaults.timeout = 100000;
axios.defaults.withCredentials = true;
axios.defaults.baseURL = "http://" + window.location.host;
axios.defaults.port = ":" + window.location.port;
// 캐싱 방지
axios.defaults.headers.get['Cache-Control'] = 'no-cache';
axios.defaults.headers.get['Pragma'] = 'no-cache';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Access-Control-Allow-Headers'] = '*';
axios.defaults.headers.common['Access-Control-Allow-Methods'] = "POST, GET, OPTIONS"
axios.defaults.headers.common['Access-Control-Allow-Credentials'] = true;

axios.interceptors.request.use((request) => {
    if (request.port != ":9000") {
        if (request.url.indexOf("/py_api/") > -1) {
            // request.baseURL = "http://api.nodebee.kr";       // 기존에 사용하던 api 주소(24.06.05)변경
            request.baseURL = "http://13.125.105.232";
            request.url = request.url.replace("/py_api", "");
        }
        /*if (request.url.indexOf("/app_api/") > -1) {
            request.baseURL = "http://app-api.nodebee.kr";
            request.url = request.url.replace("/app_api", "");
        }*/
        if (request.url.indexOf("/new_api/") > -1) {
            // request.baseURL = "http://115.85.181.86:18080/"; // 기존에 사용하던 api 주소(24.06.05)변경
            request.baseURL = "http://13.125.105.232";
            request.url = request.url.replace("/new_api", "/api");
        }
    }
    // request.headers.authorization = "Bearer " + localStorage.getItem('authorization');
    // request.headers.authorization = localStorage.getItem('authorization');
    // return request;

    // authorization 가 있을 때에만 request
    const token = localStorage.getItem('authorization');
    if (token) {
        request.headers.authorization = token;
    }
    return request;
})


// url에서 www 입력시 제거 하기
const host = window.location.href;
if (host.indexOf("www.") > -1) {
    document.location.href = window.location.href.replace("www.", "");
}

const app = createApp(App);
app.config.globalProperties.axios = axios;
app.component('Datepicker', Datepicker);
app.use(store).use(router).mount('#app');
app.config.globalProperties.$filters = {
    dateformat(value) {
        if (!value) return '';

        if (typeof value === 'string') {
            return value.substring(0, 10);
        }
        return '';
    },
    numberformat(value) {
        return Number(value).toLocaleString();
    },
    getDate(d) {
        var month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }
}

